// no itx for this file
import Channel from "../models/Channel";
import { ChannelType, channelTypeInfo } from "../models/ChannelType";
import Signal from "../models/Signal";
import { getSignalTypeBundle, getSignalTypeBundleWithoutScene } from "../models/SignalBundles";
import SignalType from "../models/SignalType";
import SignalTypes from "../models/SignalTypes";
import ButtonChannel from "../models/ButtonChannel";
import Logger from "../Logger";
import type Device from "../models/Device";
import { TAG_ENVIRONMENT } from "../models/Constants";
import { productionAssert } from "../models/utils";

const _FILENAME_ = "groupGeneralSignalsIntoChannelsForButton.ts";
const logger = new Logger();

function intersect(
  setA: Map<ChannelType, Array<SignalType>> | undefined,
  setB: Map<ChannelType, Array<SignalType>> | undefined,
): Map<ChannelType, Array<SignalType>> | undefined {
  const res = new Map<ChannelType, Array<SignalType>>();

  if (setA && setB) {
    setA.forEach((signalBundleA, channelType) => {
      if (setB.has(channelType)) {
        res.set(channelType, signalBundleA);
      }
    });
    if (res.size > 0) {
      return res;
    }
  }

  return undefined;
}

function hasMultipleSwitchCommandButtons(channel: Channel) {
  var cnt = 0;
  channel.signals.forEach((signal) => {
    if (signal.type.name == SignalTypes.Switch.name) {
      cnt++;
    }
  });
  return cnt > 1;
}

function channelName(signalname: string): string {
  let index = signalname.indexOf(":");
  if (index < 0) {
    index = signalname.indexOf("-"); // for Busch Jäger
  }

  if (index != -1) {
    return signalname.slice(0, index);
  }

  return signalname;
}

// export function groupGeneralSignalsIntoChannelsForButton(channels: Array<Channel>): Array<Channel> {
//   // collect all signals of all channel in one array
//   let allSignals = new Array<Signal>();
//   channels.forEach((channel) => {
//     channel.signals.forEach((signal) => allSignals.push(signal));
//   });

//   allSignals = sortArrayByIntProperty(allSignals, "number");

//   const newChannelGeneral = new Channel({
//     name: "General",
//     channelType: ChannelType.General,
//     isRequestChannel: false,
//   });

//   const newChannels = new Array<Channel>();

//   var possibleBundlesForThisChannel: Map<ChannelType, Array<SignalType>> | undefined = undefined;

//   var foundSignalTypesForChannel = new Array<SignalType>();
//   var currentChannel: Channel | undefined;

//   for (let i = 0; i < allSignals.length; i++) {
//     let signal = allSignals[i];
//     let possibleBundlesForThisSignal = getAllSignalBundlesWithSignalType(signal.type);

//     if (possibleBundlesForThisSignal.size == 0 && !signal.knxChannelTypeProperty) {
//       allSignals.splice(i, 1);
//       i--;
//       newChannelGeneral.signals.addWithoutUpdate(signal);
//       newChannelGeneral.mergeKnxChannelPropertyX(signal);
//     }
//   }

//   allSignals.forEach((signal) => {
//     let possibleBundlesForThisSignal = getAllSignalBundlesWithSignalType(signal.type);

//     logger.log(`MWE2 groupGeneralSignalsIntoChannelsForButton ${signal.name} ${signal.type.name}`);

//     if (currentChannel) {
//       var closeChannel = false;
//       if (foundSignalTypesForChannel.includes(signal.type)) {
//         // we found a signalType a secound time   ..
//         // that means e have to close the current channel
//         closeChannel = true;
//       } else {
//         // intersect all possible channelTypes of this signal with all pssible channel types we have so far
//         // if the intersection is empty,
//         // we jump from one channelType to another
//         // iE we have (Switch, SwitchState), ffollowed by Scene
//         //

//         possibleBundlesForThisChannel = intersect(possibleBundlesForThisChannel, possibleBundlesForThisSignal);

//         if (!possibleBundlesForThisChannel) {
//           // we found a signalType a secound time   ..
//           // that means we have to close the current channel
//           closeChannel = true;
//         }
//       }

//       if (closeChannel) {
//         // we close the current channel....
//         //
//         // this signal we open a new channel below

//         // we should have only ONE remainding option in then "foundSignalTypesForChannel" when we come here
//         // if we have more than one we have to choose the "simplest" iE "Switch"  of "Dimmer"

//         if (currentChannel && possibleBundlesForThisChannel) {
//           // we should have only ONE remainding option in then "foundSignalTypesForChannel" when we come here
//           // if we have more than one we have to choose the "simplest" iE "Switch"  of "Dimmer"
//           currentChannel.channelType = getSmallestChannelType(possibleBundlesForThisChannel);
//         }

//         //
//         // close current channel
//         //
//         possibleBundlesForThisChannel = undefined;
//         currentChannel = undefined;
//       }
//     }

//     //
//     // we have an current channel,
//     // so all signals we find, means "may belong to this channel"
//     // we have to add to the current channel
//     //
//     if (currentChannel != undefined) {
//       currentChannel.signals.addWithoutUpdate(signal);
//       currentChannel.mergeKnxChannelPropertyX(signal);
//     }

//     //
//     // check if we have to start a new channel
//     //

//     if (currentChannel == undefined && possibleBundlesForThisSignal.size > 0) {
//       possibleBundlesForThisChannel = possibleBundlesForThisSignal;

//       foundSignalTypesForChannel = new Array<SignalType>();
//       foundSignalTypesForChannel.push(signal.type);

//       currentChannel = new ButtonChannel({
//         knxChannelId: signal.knxId,
//         name: channelName(signal.name),
//         isRequestChannel: false,
//         // channelType: tp,   // will be set late, see above
//       });

//       currentChannel.signals.addWithoutUpdate(signal);
//       currentChannel.mergeKnxChannelPropertyX(signal);
//       newChannels.push(currentChannel);
//     }

//     const channelFromChannelTypeProperty = newChannels.find(
//       (c) => c.knxChannelTypeProperty == signal.knxChannelTypeProperty,
//     );
//     if (currentChannel == undefined && !channelFromChannelTypeProperty) {
//       foundSignalTypesForChannel = new Array<SignalType>();
//       foundSignalTypesForChannel.push(signal.type);

//       currentChannel = new ButtonChannel({
//         knxChannelId: signal.knxId,
//         name: channelName(signal.name),
//         isRequestChannel: false,
//         // channelType: tp,   // will be set late, see above
//       });

//       currentChannel.signals.addWithoutUpdate(signal);
//       currentChannel.mergeKnxChannelPropertyX(signal);
//       newChannels.push(currentChannel);
//     }
//   });

//   // close "last" current channel
//   if (currentChannel && possibleBundlesForThisChannel) {
//     currentChannel.channelType = getSmallestChannelType(possibleBundlesForThisChannel);
//   }

//   if (newChannelGeneral.signals.size > 0) {
//     newChannels.push(newChannelGeneral);
//   }

//   for (const oldChannel of channels.filter((c) => c.knxChannelTypeProperty && c.signals.size == 0)) {
//     const oldChannelTypeProperty = oldChannel.knxChannelTypeProperty;
//     const used = newChannels.find((c) => c.knxChannelTypeProperty == oldChannelTypeProperty);
//     if (!used) {
//       newChannels.push(oldChannel);
//     }
//   }

//   cleanUpDuplicateKnxChannelTypeProperty(newChannels)

//   return newChannels;
// }

export function cleanUpDuplicateKnxChannelTypeProperty(newChannels: Array<Channel>): Array<Channel> {
  //
  // filter channels with duplicate knxChannelTypePropertys
  //

  const allIds = new Map<string, number>();
  newChannels.forEach((channel) => {
    if (channel.knxChannelTypeProperty) {
      const cnt = allIds.get(channel.knxChannelTypeProperty.xid) || 0;
      allIds.set(channel.knxChannelTypeProperty.xid, cnt + 1);
    }
  });

  allIds.forEach((cnt, xid) => {
    if (cnt > 1) {
      //
      // Wenn eine ChannelTypeProperty mehr als einmal vorkommt, dann

      // versuchen wir als erstes
      // alle Kanäle in denen die ChannelTypeProperty an einem Dummy-Signal hängt zu löschen
      //
      let duplicateChannels = newChannels.filter((c) => c.knxChannelTypeProperty?.xid == xid);
      duplicateChannels.forEach((duplicateChannel) => {
        let dummySignal = duplicateChannel.signals.findFirst((c) => c.isDummySignal);
        if (dummySignal) {
          duplicateChannel.knxChannelTypeProperty = undefined;

          //
          // mwe 16.12.2025
          //   wir löschen den Kanal nicht mehr komplett
          //   da es sein kann, dass der Kanal trotzdem noch gebraucht wird insbesondere (TS_X)
          //
          // const i = newChannels.indexOf(duplicateChannel);
          // newChannels.splice(i, 1);
        }
      });

      // wenn wir nun trotzdem noch mehrere Kanäle mit der gleichen ChannelTypeProperty haben.
      // löschen wir die ChannelTypeProperty an alled Kanälen.
      // Dadurch wird das konkurierende/falsch setzten der ChannelTypeProperty aus 2 BUttons verhindert.
      // Eigentlich sollte sowas nicht vorkommen, und steht hier nur für den Fall der Fälle.
      //
      duplicateChannels = newChannels.filter((c) => c.knxChannelTypeProperty?.xid == xid);
      if (duplicateChannels.length > 1) {
        duplicateChannels.forEach((channel) => {
          channel.knxChannelTypeProperty = undefined;
        });
      }
    }
  });
  return newChannels;
}

//
// Combine all Environment Signals (Date, Time, Day/Night)
// into one new Channel
//
export function mergeEnvironmentSignals(device: Device, newKnxChannels: Array<Channel>): Array<Channel> {
  //
  // if we have multiple environment channels we merge them into one channel
  //

  const knxEnvironmentChannels = newKnxChannels.filter((c) => c.channelType == ChannelType.Environment);
  let knxEnvironmentChannel0 = knxEnvironmentChannels[0];

  if (knxEnvironmentChannel0 && knxEnvironmentChannels.length > 1) {
    for (let i = 1; i < knxEnvironmentChannels.length; i++) {
      const channelI = knxEnvironmentChannels[i];

      channelI.signals.forEach((signal) => {
        const existingSignal = knxEnvironmentChannel0.signals.findFirst((s) => s.number == signal.number);
        if (existingSignal) {
          productionAssert(false, _FILENAME_, 289);
        } else {
          signal.parent = knxEnvironmentChannel0;
          knxEnvironmentChannel0.addSignalWithoutUpdate(signal);
        }
      });
      newKnxChannels.splice(newKnxChannels.indexOf(channelI), 1);
    }
  }

  let environmentSignalTypeBundleWithoutScene = getSignalTypeBundleWithoutScene(ChannelType.Environment);
  if (environmentSignalTypeBundleWithoutScene) {
    const removeChannels = new Array<Channel>();

    newKnxChannels.forEach((knxChannel) => {
      if (knxChannel.channelType != ChannelType.Environment) {
        knxChannel.signals.forEach((channelSignal) => {
          const operationModeTypes = [
            SignalTypes.OperationMode.name,
            SignalTypes.OperationMode_Comfort.name,
            SignalTypes.OperationMode_Eco.name,
            SignalTypes.OperationMode_FrostProtection.name,
            SignalTypes.OperationMode_HeatProtection.name,
            SignalTypes.OperationMode_Night.name,
          ];
          const isOperationMode = operationModeTypes.includes(channelSignal.type.name);

          let moveSignal = false;

          //
          // now we move all environment signals (part of environmentSignalTypeBundle)
          // into this one environment channel
          //

          if (
            !isOperationMode &&
            environmentSignalTypeBundleWithoutScene.findIndex((bundleSignalType) =>
              bundleSignalType.equals(channelSignal.type),
            ) >= 0
          ) {
            moveSignal = true;
          }

          //
          // we also move scene signals from "hidden" Channels
          // into this one environment channel
          //

          if (
            [
              ChannelType.Unknown,
              ChannelType.UnknownMapWithScript,
              ChannelType.GenericValue,
              ChannelType.Ignored,
            ].includes(knxChannel.channelType) &&
            channelSignal.type.name == SignalTypes.Scene.name
          ) {
            moveSignal = true;
          }

          if (moveSignal) {
            if (!knxEnvironmentChannel0) {
              //
              // if we dont have ANY environment channel so far,
              // we create a new one
              //

              knxEnvironmentChannel0 = device.createEnvironmentChannel();
              newKnxChannels.push(knxEnvironmentChannel0);
            }

            knxEnvironmentChannel0.addSignalWithoutUpdate(channelSignal);

            if (knxChannel.signals.size == 0) {
              removeChannels.push(knxChannel);
            }
          }
        });
      }
    });

    newKnxChannels = newKnxChannels.filter((c) => !removeChannels.includes(c));
  }

  return newKnxChannels;
}

//
// Combine Temperatur-Mesurement- & Temperature-Setting- Channels to
// ONE Heating Channel
//
// If we have more the 2 channels we cant merge
// in this case we have for example 5 temperature setpoints for different rooms (ie with a GVS touch button)
//

export function mergeTemperaturChannels(newChannels: Array<Channel>): Array<Channel> {
  const allTemperatureSetpointChannels = newChannels.filter(
    (channel) =>
      !channel.isActorChannel &&
      (channel.channelType == ChannelType.TemperatureSetpoint || channel.channelType == ChannelType.Heating),
  );

  const temperatureMeasurementChannels = newChannels.filter(
    (channel) => channel.channelType == ChannelType.TemperatureMeasurement,
  );

  if (allTemperatureSetpointChannels.length == 1 && temperatureMeasurementChannels.length == 1) {
    const theOnlyTemperaturChannel = allTemperatureSetpointChannels[0];
    const theMeasurementChannel = temperatureMeasurementChannels[0];

    theOnlyTemperaturChannel.channelType = ChannelType.Heating;

    theMeasurementChannel.signals.forEach((signal) => {
      theOnlyTemperaturChannel.addSignalWithoutUpdate(signal);
    });

    //
    // delete measurement Channel
    //
    const del = newChannels.indexOf(theMeasurementChannel);
    newChannels.splice(del, 1);
  }

  return newChannels;
}

//
// if a channel has signal names all forming the same channelName erverything is ok
// if not we change the channel name to the typeName of the channel + number
//
export function manageChannelNamesWithInhomogeSignalnames(channels: Array<Channel>) {
  const counts: any = {};

  channels.forEach((channel) => {
    if (channel.channelType != ChannelType.General && channel.channelType != ChannelType.Environment) {
      const xSignals = channel.signals.asArray();

      let signalNamesAreDifferent = false;
      for (let i = 0; i < xSignals.length; i++) {
        for (let j = i + 1; j < xSignals.length; j++) {
          if (channelName(xSignals[i].name) != channelName(xSignals[j].name)) {
            signalNamesAreDifferent = true;
          }
        }
      }

      if (signalNamesAreDifferent) {
        let name = state.translate(`channelType.${channel.channelType}`, channel.channelType);

        if (channel.channelType != ChannelType.Heating && channel.channelType != ChannelType.TemperatureMeasurement) {
          const count = counts[channel.channelType] || 1;
          name += ` ${count}`;
          counts[channel.channelType] = count + 1;
        }

        channel.name = name;
      }
    }
  });
}
